import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LOGO } from "../lib/menu";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Inloggen mislukt.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1B6B2E] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        className="bg-white w-full max-w-md p-8 flex flex-col items-center"
        data-testid="admin-login-form"
      >
        <img src={LOGO} alt="De Zeeuwse Tori" className="w-20 h-20 rounded-full object-cover" />
        <h1 className="text-2xl font-[700] text-[#0D3B4C] mt-4 flex items-center gap-2">
          <Lock size={22} /> Admin login
        </h1>
        <div className="w-full mt-6 space-y-4">
          <div>
            <label className="block font-[600] text-[#0D3B4C] mb-1">E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="w-full border-2 border-[#0D3B4C] px-4 py-3 focus:border-[#B71C1C] focus:outline-none"
            />
          </div>
          <div>
            <label className="block font-[600] text-[#0D3B4C] mb-1">Wachtwoord</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="w-full border-2 border-[#0D3B4C] px-4 py-3 focus:border-[#B71C1C] focus:outline-none"
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="w-full mt-6 bg-[#B71C1C] text-white font-[700] uppercase tracking-wider py-4 hover:bg-[#8E1515] transition-colors disabled:opacity-50"
        >
          {loading ? "Bezig..." : "Inloggen"}
        </button>
      </form>
    </div>
  );
}
